import React from 'react';

export default class extends React.PureComponent {
  static displayName = 'Submit';

  render() {
    const attrs = {};
    if (!this.props.disabled) attrs.onClick = this.props.onSubmit;
    return (
      <button
        data-testid={this.props.dataTestProp}
        className={`BookingRequest-submit brand-bg ${
          this.props.disabled ? 'disabled' : ''
        }`}
        href="javascript:void(0)"
        {...attrs}
      >
        {this.props.label}
      </button>
    );
  }
}
